'use client'

import { Media, TimeLine as TimeLineType } from '@/payload-types';
import { TypedLocale } from 'payload';
import React from 'react';

export const TimeLineBlock: React.FC<TimeLineType & {
  id?: string,
  locale: TypedLocale
}> = ({
  locale, blockName, timeline, image
}) => {
 
  return  <Timeline content={timeline} image={image as Media} />
};

const TimelineItem = ({ title, content, isLeft } : any) => (
  <div className={`container grid md:flex ${isLeft ? 'flex-row' : 'flex-row-reverse'} w-full mb-8`}>
    <div className="w-full md:w-5/12">
      <h2 className="silver-large-text text-3xl my-8">{title}</h2>
    </div>
    <div className="w-2/12 flex justify-center">
      <div className="w-1 bg-white"></div>
    </div>
    <div className="md:w-5/12 p-4 bg-black bg-opacity-50 rounded-lg w-full">
      {/* <h3 className="text-xl font-bold text-white mb-2">{title}</h3> */}
      <p className="text-gray-300">{content}</p>
    </div>
  </div>
);

const Timeline = ({ content, image }: { content: any, image: Media }) => (
  <div data-theme="dark" className="w-full  min-h-screen relative bg-fixed bg-cover bg-no-repeat py-16 px-4"
    style={{
      backgroundImage: `url("${image.url}")`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
    }}
  >
    <div className="absolute inset-0 bg-black opacity-70"></div>
    <div className="relative z-10 w-full md:max-w-4xl mx-auto">
      {content?.map((item: any, index: number) => (
        <TimelineItem
          key={index}
          title={item.title}
          content={item.content}
          isLeft={index % 2 === 0}
        />
      ))}
    </div>
  </div>
);
